export default function TimerIcon() {
  return (
    <>
      <rect width='12' height='12' rx='6' fill='#A0383F' />
      <path d='M6 6V0H12V6H6Z' fill='white' />
    </>
  );
}
